import type { OrderStatus } from '@wms/shared';

export function canAmendOrderLines(input: {
  status: OrderStatus;
  roles: readonly string[];
  invoiceNumber: string | null;
  invoicePushState: string | null;
}): boolean {
  if (input.invoiceNumber || input.invoicePushState) return false;
  const warehouseActor = input.roles.some((role) => role === 'ADMIN' || role === 'OPERATOR');
  if (warehouseActor) {
    return ['SUBMITTED', 'ON_HOLD', 'IN_ASSEMBLY'].includes(input.status);
  }
  const partnerActor = input.roles.some(
    (role) => role === 'PARTNER_ADMIN' || role === 'ORDER_PLACER',
  );
  return partnerActor && input.status === 'SUBMITTED';
}
